var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/contentful/render-entry.j2"] = require( "macros/contentful/render-entry.j2" );
dependencies["macros/contentful/reverse-row.j2"] = require( "macros/contentful/reverse-row.j2" );
dependencies["macros/contentful/full-bleed.j2"] = require( "macros/contentful/full-bleed.j2" );
dependencies["contentful/module-headline.j2"] = require( "contentful/module-headline.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/render-modules.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/contentful/render-entry.j2", false, "core/templates/contentful/render-modules.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("renderEntry")) {
var t_4 = t_1.renderEntry;
} else {
cb(new Error("cannot import 'renderEntry'")); return;
}
context.setVariable("renderEntry", t_4);
env.getTemplate("macros/contentful/reverse-row.j2", false, "core/templates/contentful/render-modules.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("determineReverseRow")) {
var t_8 = t_5.determineReverseRow;
} else {
cb(new Error("cannot import 'determineReverseRow'")); return;
}
context.setVariable("determineReverseRow", t_8);
env.getTemplate("macros/contentful/full-bleed.j2", false, "core/templates/contentful/render-modules.j2", false, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
t_9.getExported(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
if(t_9.hasOwnProperty("determineFullBleed")) {
var t_12 = t_9.determineFullBleed;
} else {
cb(new Error("cannot import 'determineFullBleed'")); return;
}
context.setVariable("determineFullBleed", t_12);
if(runtime.contextOrFrameLookup(context, frame, "data")) {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"fields")) {
output += "\n        ";
var t_13;
t_13 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"fields")),"modules");
frame.set("modules", t_13, true);
if(frame.topLevel) {
context.setVariable("modules", t_13);
}
if(frame.topLevel) {
context.addExport("modules", t_13);
}
output += "\n    ";
;
}
else {
output += "\n        ";
var t_14;
t_14 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"modules");
frame.set("modules", t_14, true);
if(frame.topLevel) {
context.setVariable("modules", t_14);
}
if(frame.topLevel) {
context.addExport("modules", t_14);
}
output += "\n    ";
;
}
output += "\n";
;
}
output += "\n\n<div class=\"dom-landing-page-modules\">\n    ";
if(runtime.contextOrFrameLookup(context, frame, "modules")) {
frame = frame.push();
var t_17 = runtime.contextOrFrameLookup(context, frame, "modules");
if(t_17) {var t_16 = t_17.length;
for(var t_15=0; t_15 < t_17.length; t_15++) {
var t_18 = t_17[t_15];
frame.set("module", t_18);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
var t_19;
t_19 = (runtime.memberLookup((runtime.memberLookup((t_18),"fields")),"slug")?"s-" + "" + runtime.memberLookup((runtime.memberLookup((t_18),"fields")),"slug"):"");
frame.set("slugClass", t_19, true);
if(frame.topLevel) {
context.setVariable("slugClass", t_19);
}
if(frame.topLevel) {
context.addExport("slugClass", t_19);
}
output += "\n            ";
var t_20;
t_20 = (runtime.contextOrFrameLookup(context, frame, "slugClass") + "" + " " + "" + (lineno = 17, colno = 37, runtime.callWrap(t_8, "determineReverseRow", context, [t_18])) + "" + " " + "" + (lineno = 18, colno = 36, runtime.callWrap(t_12, "determineFullBleed", context, [t_18])));
frame.set("classList", t_20, true);
if(frame.topLevel) {
context.setVariable("classList", t_20);
}
if(frame.topLevel) {
context.addExport("classList", t_20);
}
output += "\n            <!-- module -->\n            <div class=\"o-row ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "classList"), env.opts.autoescape);
output += "\" data-qa-module-type=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_18),"fields")),"contentType"), env.opts.autoescape);
output += "\" data-qa-module-length=\"";
output += runtime.suppressValue(env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((t_18),"fields")),"components")), env.opts.autoescape);
output += "\"";
if(runtime.memberLookup((runtime.memberLookup((t_18),"fields")),"slug")) {
output += "\n                    id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_18),"fields")),"slug"), env.opts.autoescape);
output += "\"\n                ";
;
}
output += ">\n\n                ";
env.getTemplate("contentful/module-headline.j2", false, "core/templates/contentful/render-modules.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n\n                ";
var t_25;
t_25 = runtime.contextOrFrameLookup(context, frame, "loop");
frame.set("entryloop", t_25, true);
if(frame.topLevel) {
context.setVariable("entryloop", t_25);
}
if(frame.topLevel) {
context.addExport("entryloop", t_25);
}
output += "\n                ";
var t_26;
t_26 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index");
frame.set("entryloopindex", t_26, true);
if(frame.topLevel) {
context.setVariable("entryloopindex", t_26);
}
if(frame.topLevel) {
context.addExport("entryloopindex", t_26);
}
output += "\n                ";
var t_27;
t_27 = t_18;
frame.set("entry", t_27, true);
if(frame.topLevel) {
context.setVariable("entry", t_27);
}
if(frame.topLevel) {
context.addExport("entry", t_27);
}
output += "\n                ";
var t_28;
t_28 = true;
frame.set("topLevel", t_28, true);
if(frame.topLevel) {
context.setVariable("topLevel", t_28);
}
if(frame.topLevel) {
context.addExport("topLevel", t_28);
}
output += "\n                ";
var t_29;
t_29 = ((lineno = 33, colno = 50, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product"]))?true:false);
frame.set("pdpLazyModules", t_29, true);
if(frame.topLevel) {
context.setVariable("pdpLazyModules", t_29);
}
if(frame.topLevel) {
context.addExport("pdpLazyModules", t_29);
}
output += "\n                ";
var t_30;
t_30 = (runtime.contextOrFrameLookup(context, frame, "disableLazyLoad")?true:false);
frame.set("disableLazyLoad", t_30, true);
if(frame.topLevel) {
context.setVariable("disableLazyLoad", t_30);
}
if(frame.topLevel) {
context.addExport("disableLazyLoad", t_30);
}
output += "\n                ";
var t_31;
t_31 = runtime.contextOrFrameLookup(context, frame, "entryloopindex") && runtime.contextOrFrameLookup(context, frame, "entryloopindex") > (lineno = 35, colno = 82, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.lazyLoad.landing_page_normal_count"]));
frame.set("isLargeLandingPage", t_31, true);
if(frame.topLevel) {
context.setVariable("isLargeLandingPage", t_31);
}
if(frame.topLevel) {
context.addExport("isLargeLandingPage", t_31);
}
output += "\n                ";
var t_32;
t_32 = (runtime.contextOrFrameLookup(context, frame, "isLargeLandingPage") || runtime.contextOrFrameLookup(context, frame, "pdpLazyModules")) && !runtime.contextOrFrameLookup(context, frame, "disableLazyLoad");
frame.set("shouldLazyLoad", t_32, true);
if(frame.topLevel) {
context.setVariable("shouldLazyLoad", t_32);
}
if(frame.topLevel) {
context.addExport("shouldLazyLoad", t_32);
}
output += "\n\n                ";
if(runtime.contextOrFrameLookup(context, frame, "shouldLazyLoad")) {
output += "\n                    ";
var t_33;
t_33 = true;
frame.set("isLazy", t_33, true);
if(frame.topLevel) {
context.setVariable("isLazy", t_33);
}
if(frame.topLevel) {
context.addExport("isLazy", t_33);
}
output += "\n                ";
;
}
else {
output += "\n                    ";
var t_34;
t_34 = false;
frame.set("isLazy", t_34, true);
if(frame.topLevel) {
context.setVariable("isLazy", t_34);
}
if(frame.topLevel) {
context.addExport("isLazy", t_34);
}
output += "\n                ";
;
}
output += "\n\n                ";
output += runtime.suppressValue((lineno = 44, colno = 28, runtime.callWrap(t_4, "renderEntry", context, [runtime.contextOrFrameLookup(context, frame, "entry"),runtime.makeKeywordArgs({"entryloop": runtime.contextOrFrameLookup(context, frame, "entryloop"),"isLazy": runtime.contextOrFrameLookup(context, frame, "isLazy")})])), env.opts.autoescape);
output += "\n            </div>";
})});
}
}
frame = frame.pop();
;
}
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/render-modules.j2"] , dependencies)